// extracted by mini-css-extract-plugin
export default {"tooltipChecklist":"tooltip-checklist_tooltipChecklist__TveOT","checklistItem":"tooltip-checklist_checklistItem__kluwr","unchecked":"tooltip-checklist_unchecked__sG64o"};